export default __webpack_public_path__ + "static/media/3.86de1fdb.jpeg";